import React from 'react';
import ContactForm from './ContactForm';
import QuoteForm from './QuoteForm';

const FormsSection = () => {
  return (
    <section id="contact" className="py-24 bg-gradient-to-br from-gray-50 to-slate-100">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#FF6600] font-semibold text-sm uppercase tracking-wider">Contactez-nous</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mt-3 mb-4">
            Parlons de Votre Projet
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Vous avez un projet de mise aux normes ou d'installation d'équipements de quai ? Nous sommes là pour vous accompagner.
          </p>
        </div>

        {/* Forms Grid */}
        <div className="grid lg:grid-cols-2 gap-8 max-w-7xl mx-auto">
          {/* Contact Form */}
          <ContactForm />

          {/* Quote Form */}
          <div id="quote">
            <QuoteForm />
          </div>
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 max-w-4xl mx-auto">
          <div className="bg-white rounded-xl shadow-md p-8 border border-gray-200">
            <div className="grid md:grid-cols-3 gap-6 text-center">
              <div>
                <div className="text-[#FF6600] font-bold text-3xl mb-2">24h</div>
                <p className="text-gray-600 text-sm">Délai de réponse</p>
              </div>
              <div className="border-l border-r border-gray-200">
                <div className="text-[#FF6600] font-bold text-3xl mb-2">100%</div>
                <p className="text-gray-600 text-sm">Devis gratuits</p>
              </div>
              <div>
                <div className="text-[#FF6600] font-bold text-3xl mb-2">Expert</div>
                <p className="text-gray-600 text-sm">Conseil personnalisé</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FormsSection;
